module.exports = __webpack_public_path__ + "img/success-logo.18217a38.png";